var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgSales = function SvgSales(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 168.72 168.72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M90.29,108.06H78.43a5.93,5.93,0,0,1-5.92-5.92H31.09v23.7a11.88,11.88,0,0,0,11.85,11.85h82.9a11.88,11.88,0,0,0,11.85-11.85v-23.7H96.21A5.93,5.93,0,0,1,90.29,108.06Zm41.48-53.33H108.06a23.7,23.7,0,0,0-47.4,0H37A11.88,11.88,0,0,0,25.1,66.58V84.36A11.8,11.8,0,0,0,37,96.21H72.51V90.29a5.94,5.94,0,0,1,5.92-5.93H90.29a5.94,5.94,0,0,1,5.92,5.93v5.92h35.56a11.88,11.88,0,0,0,11.85-11.85V66.58A11.88,11.88,0,0,0,131.77,54.73Zm-59.26,0a11.85,11.85,0,0,1,23.7,0H72.51Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSales, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sales.6f91005d.svg";
export { ForwardRef as ReactComponent };